// slider custom

$('.sliderView').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    speed: 500,
    loop: true,
    arrows: true,
    dots:true,
    asNavFor: '.sliderThumb'
});


$('.sliderThumb').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.sliderView',
    dots: false,
    loop: true,
    arrows: false,
    focusOnSelect: true,
    verticalSwiping: true,
    speed: 500,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                vertical: true,
                dots:true,
            }
        },
        {
            breakpoint: 768,
            settings: {
                vertical: true,
            }
        },
        {
            breakpoint: 580,
            settings: {
                vertical: true,
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 380,
            settings: {
                vertical: true,
                slidesToShow: 2,
            }
        }
    ]
});


// Hide review widget
setInterval(function() {
    setTimeout(function() {
        $('.yotpo-sr-star-empty').parent().parent().hide();
    }, 2000); // 2000 milliseconds = 2 seconds
}, 1000);
// remove extra slides
function hideSpecificSlides() {
    $('.slider').each(function() {
      var slider = $(this);
      var slides = slider.find('.slick-slide');

      slides.each(function() {
        var slickIndex = parseInt($(this).attr('data-slick-index'));

        if (slickIndex === 0 || slickIndex === 6 || slickIndex === 7 || slickIndex === 8) {
          $(this).hide();
        }
      });
    });
  }

  // Run the function immediately
  hideSpecificSlides();
  // Then, run it every 2 seconds
  setInterval(hideSpecificSlides, 1000);

// Add to cart //
const plus = document.querySelector(".plus"),
    minus = document.querySelector(".minus"),
    num = document.querySelector(".num");

window.addEventListener("load", ()=> {
    if (localStorage["num"]) {
        num.innerText = localStorage.getItem("num");
    } else {
        let a = "01";
        num.innerText = a;
    }
});

plus.addEventListener("click", ()=> {
    a = num.innerText;
    a++;
    a = (a < 10) ? "0" + a : a;
    localStorage.setItem("num", a);
    num.innerText = localStorage.getItem("num");
});

minus.addEventListener("click", ()=> {
    a = num.innerText;
    if (a > 1) {
        a--;
        a = (a < 10) ? "0" + a : a;
        localStorage.setItem("num", a);
        num.innerText = localStorage.getItem("num");
    }
}); 


// accordion js //
var CFAccordion=function(t,e){"use strict";this.el=document.getElementById(t),this.elems=[],this.cons=[],this.heightArray=[],this.openArray=[],this.mode=e,this.init()};CFAccordion.prototype.init=function(){"use strict";this.elems=this.getLevelElements(this.el,"h3");for(var t=0;t<this.elems.length;t++)this.setListener(t);this.cons=this.getLevelElements(this.el,"div");for(var e=0;e<this.cons.length;e++){this.heightArray.push(this.cons[e].offsetHeight);try{this.cons[e].style.height="0px"}catch(t){this.cons[e].style.setProperty("height","0px")}}},CFAccordion.prototype.setListener=function(t){"use strict";var e=this;var s;this.elems[t].addEventListener("click",(function(){e.openTab(t)}),!1)},CFAccordion.prototype.openTab=function(t){"use strict";var e=this;if(-1===this.openArray.indexOf(t)){if("dynamic"===this.mode)for(var s=0;s<this.cons.length;s++){try{this.cons[s].style.height="0px"}catch(t){this.cons[s].style.setProperty("height","0px")}this.elems[s].className="",this.openArray.splice(this.openArray.indexOf(t),1)}try{this.cons[t].style.height=this.heightArray[t]+"px"}catch(e){this.cons[t].style.setProperty("height",this.heightArray[t]+"px")}this.elems[t].className="opentab",this.openArray.push(t)}else{try{this.cons[t].style.height="0px"}catch(e){this.cons[t].style.setProperty("height","0px")}this.elems[t].className="",this.openArray.splice(this.openArray.indexOf(t),1)}},CFAccordion.prototype.initialOpen=function(t){"use strict";var e;this.openTab(t)},CFAccordion.prototype.collapseAll=function(t){"use strict";for(var e=0;e<this.cons.length;e++){try{this.cons[e].style.height="0px"}catch(t){this.cons[e].style.setProperty("height","0px")}this.elems[e].className="",this.openArray.splice(this.heightArray[t]+"px")}},CFAccordion.prototype.expandAll=function(){"use strict";for(var t=0;t<this.cons.length;t++){try{this.cons[t].style.height=this.heightArray[t]+"px"}catch(e){this.cons[t].style.setProperty("height",this.heightArray[t]+"px")}this.elems[t].className="opentab",this.openArray.push(t)}},CFAccordion.prototype.getLevelElements=function(t,e){"use strict";var s=t.getElementsByTagName(e);var i=[];for(var h=0;h<s.length;h++)s[h].parentNode===t&&i.push(s[h]);return i};

var myAccordion = new CFAccordion("myAccordion", 'dynamic');
    myAccordion.initialOpen(0);
//# sourceMappingURL=/s/files/1/0216/7720/t/489/assets/CFAccordion.js.map?v=9299452596874645478
// Aos animation //
